import { render } from "./privacyPolicy.vue?vue&type=template&id=d82a160e&scoped=true"
const script = {}

import "./privacyPolicy.vue?vue&type=style&index=0&id=d82a160e&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82a160e"]])

export default __exports__